import React,{useContext} from 'react'
import PrefixContext from "../../../../context/PrefixContext.js";

function Profile(props) {

    const PrefixContextData = useContext(PrefixContext);
    var personImg;
    if(props.image !== undefined)
    {
        personImg = PrefixContextData.cdnPrefixUrl+'uploaded/'+props.image;
    }
    else{
        personImg = PrefixContextData.cdnPrefixUrl+'avtaar_A-JQZIHAe.png';
    }

    let hexagonStyle = {
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundColor: 'whitesmoke',
      backgroundImage: "url('" + personImg + "')"
    };

    return (
        <>
            <div className="hexagon-container">
                <div className="hexagon">
                    <div className="hexagon-in1">
                        <div className="hexagon-in2" style={hexagonStyle}>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Profile
